import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { CircleCheck, Clock, LinkIcon } from 'lucide-react';

import { LINK_STATE } from '../constants/invitationStates.js';
import InvitationShell from './InvitationShell';

const VARIANTS = {
  [LINK_STATE.EXPIRED]: { icon: Clock, key: 'expired' },
  [LINK_STATE.USED]: { icon: CircleCheck, key: 'used' },
  [LINK_STATE.INVALID]: { icon: LinkIcon, key: 'invalid' },
};

/**
 * A link that cannot be accepted: expired, already used or not valid. Explains why and what to
 * do; never offers an accept action.
 *
 * @param {object} props
 * @param {'expired'|'used'|'invalid'} props.variant One of `LINK_STATE`.
 */
const InvitationStatusScreen = ({ variant }) => {
  const { t } = useTranslation('people-access');
  const { icon: Icon, key } = VARIANTS[variant] ?? VARIANTS[LINK_STATE.INVALID];

  return (
    <InvitationShell>
      <Icon size={32} className="text-content-muted" aria-hidden />
      <div>
        <h1 className="m-0 text-xl font-semibold text-content">
          {t(`invitation.status.${key}.title`)}
        </h1>
        <p className="m-0 mt-1 text-sm text-content-muted">{t(`invitation.status.${key}.subtitle`)}</p>
      </div>
    </InvitationShell>
  );
};

export default memo(InvitationStatusScreen);
